(function() {
  'use strict';

  angular.module('component.users', [
  ]);
})();
